/**
 * Type for a function that makes an object reactive.
 * This allows different frameworks (Vue, React, etc.) to provide their own reactivity implementation.
 */
export type MakeReactive<T> = (obj: T) => T;

/**
 * Default no-op implementation that just returns the object as-is.
 * This is used when no reactivity system is provided (e.g., on the server).
 */
export const noopMakeReactive: MakeReactive<unknown> = <T>(obj: T): T => obj;

